// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"Divider_horizontal__0978k","vertical":"Divider_vertical__PNg65"};